"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useBreadcrumbs } from "./useBreadcrumbs";
import { BreadcrumbContext } from "./BreadcrumbsContext";
export const BreadcrumbProvider = ({ crumb, children }) => {
    const previousCrumbs = useBreadcrumbs();
    const crumbs = useMemo(() => [...previousCrumbs, crumb], [previousCrumbs, crumb]);
    return (_jsx(BreadcrumbContext.Provider, { value: crumbs, children: children }));
};
//# sourceMappingURL=BreadcrumbsProvider.js.map